export default __webpack_public_path__ + "static/logo-white-736491fca91622bb7d4ab69660ce4fe3.png";